import { Env } from "../../../index";
import { IntegrationsCatalog } from "../../classes/integration/Integration";
import plutioIntegrationProd from "./prod/plutio";
import airtableIntegrationProd from "./prod/airtable";
import dropboxIntegrationProd from "./prod/dropbox";
import githubIntegrationProd from "./prod/github";
import googleIntegrationProd from "./prod/google";

const prodIntegrations = new IntegrationsCatalog({
	integrations: [],
});

const stageIntegrations = new IntegrationsCatalog({
	integrations: [
		plutioIntegrationProd,
		githubIntegrationProd,
		airtableIntegrationProd,
		dropboxIntegrationProd,
		googleIntegrationProd,
	],
});

const integrations = (env: Env) => {
	switch (env) {
		case Env.STAGE:
			return stageIntegrations;
		default:
			return prodIntegrations;
	}
};

export { integrations };
